import { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { useDroneDetailContext } from '../Contexts/DroneDetailContext';

function ChangedFeatureDetector() {
  const { restart } = useForm();
  const { selectedFeature } = useDroneDetailContext();

  useEffect(() => {
      if(selectedFeature) {
        restart(selectedFeature.properties);
      }
  }, [selectedFeature]);

  return null;
}

export default ChangedFeatureDetector;